import FeeIcon from '../../../assets/icons/fee/fee.svg';

const Fee = ({ size }: { size: number }) => {
    return <FeeIcon width={size} height={size} />;
};

export default Fee;
